import React from "react"

const ProductContext = React.createContext()

export const useProductContext = () => {
  return React.useContext(ProductContext)
}

export default ProductContext
